import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/config';

/**
 * 대상자 한 명의 머리말 정보(이름·나이·성별·스마트링 착용 여부)를 읽는다.
 *
 * 설문·보고서·케어플랜 화면은 주소로 바로 열린다. 그때 이름을 몰라 '대상자 42' 로
 * 부르고, 스마트링 착용 여부도 몰라 탭을 늘 감췄다 — 개요에서 보이던 탭이 다른 탭으로
 * 옮기면 사라졌다(2026-09-17 보고).
 *
 * ⚠️ 라우터 state 로 이름을 나르지 않는다. 낡은 state 는 **다른 대상자 화면에 남의
 *    이름을 띄운다**(PatientTabs.js 의 주석과 같은 이유). 서버에 묻는다.
 * ⚠️ 실패해도 화면은 그대로 뜬다. 이름 자리에 id 가 남을 뿐이다.
 */
export default function usePatientSummary(appUserId) {
    const [summary, setSummary] = useState(null);

    useEffect(() => {
        if (!appUserId) return undefined;
        let cancelled = false;

        (async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(
                    `${API_BASE_URL}/api/patients/${appUserId}/summary`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (!cancelled) setSummary(response.data || null);
            } catch (error) {
                console.error('대상자 요약 조회 실패:', error.message);
                if (!cancelled) setSummary(null);
            }
        })();

        return () => { cancelled = true; };
    }, [appUserId]);

    return summary;
}
